import { CREATE_CATEGORIES, assetClassLabel } from './productConstants';
import { playTypeLabel } from './productFormUtils';

function PlayTypeRadios({ value, onChange, disabled = false }) {
  return (
    <div className={`product-type-radios ${disabled ? 'is-disabled' : ''}`}>
      {CREATE_CATEGORIES.map((item) => (
        <label key={item.key} className="product-type-radios__item">
          <input
            type="radio"
            name="createCategory"
            value={item.key}
            checked={value === item.key}
            onChange={() => onChange(item.key)}
            disabled={disabled}
          />
          <span>{item.label}</span>
        </label>
      ))}
    </div>
  );
}

function ProductFormFields({ form, onChange, playType, symbols, symbolsLoading, pairReadonly, hideTimedDurationFields }) {
  const selectedSymbol = symbols.find((item) => item.code === form.marketSymbolCode);

  return (
    <>
      <div className="admin-form-row">
        <label className="admin-form-row__label required">交易對：</label>
        <div className="admin-form-row__control">
          {pairReadonly ? (
            <input type="text" value={form.pairLabel || form.marketSymbolCode} disabled />
          ) : (
            <select
              value={form.marketSymbolCode}
              onChange={(e) => onChange('marketSymbolCode', e.target.value)}
              required
              disabled={symbolsLoading}
            >
              <option value="">請選擇</option>
              {symbols.map((symbol) => (
                <option key={symbol.code} value={symbol.code}>
                  {symbol.displayName || symbol.code}
                </option>
              ))}
            </select>
          )}
        </div>
      </div>

      <div className="admin-form-row">
        <label className="admin-form-row__label">自定義名稱：</label>
        <div className="admin-form-row__control">
          <input
            type="text"
            value={form.customName}
            onChange={(e) => onChange('customName', e.target.value)}
          />
        </div>
      </div>

      <div className="admin-form-row">
        <label className="admin-form-row__label">商品圖標顯示：</label>
        <div className="admin-form-row__control">
          <label className="switch">
            <input
              type="checkbox"
              checked={form.showIcon}
              onChange={(e) => onChange('showIcon', e.target.checked)}
            />
            <span className="switch__slider" />
          </label>
        </div>
      </div>

      <div className="admin-form-row">
        <label className="admin-form-row__label">前台顯示轉換匯率：</label>
        <div className="admin-form-row__control">
          <input
            type="number"
            min="0"
            step="any"
            value={form.conversionRate}
            onChange={(e) => onChange('conversionRate', e.target.value)}
          />
          <p className="form-hint form-hint--danger">
            若前台價格幣種為 CNY，需以 USD 顯示，可輸入轉換匯率；輸入 1 或不填則不轉換。
          </p>
        </div>
      </div>

      <div className="admin-form-row">
        <label className="admin-form-row__label">顯示每克價格：</label>
        <div className="admin-form-row__control">
          <label className="switch">
            <input
              type="checkbox"
              checked={form.showPricePerGram}
              onChange={(e) => onChange('showPricePerGram', e.target.checked)}
            />
            <span className="switch__slider" />
          </label>
        </div>
      </div>

      <div className="admin-form-row">
        <label className="admin-form-row__label required">最小下單金額(USDT)：</label>
        <div className="admin-form-row__control admin-form-row__control--suffix">
          <input
            type="number"
            min="0"
            step="any"
            value={form.minOrderAmount}
            onChange={(e) => onChange('minOrderAmount', e.target.value)}
            required
          />
          <span className="admin-form-row__suffix">0表示不限制</span>
        </div>
      </div>

      <div className="admin-form-row">
        <label className="admin-form-row__label required">最大下單金額(USDT)：</label>
        <div className="admin-form-row__control admin-form-row__control--suffix">
          <input
            type="number"
            min="0"
            step="any"
            value={form.maxOrderAmount}
            onChange={(e) => onChange('maxOrderAmount', e.target.value)}
            required
          />
          <span className="admin-form-row__suffix">0表示不限制</span>
        </div>
      </div>

      <div className="admin-form-row">
        <label className="admin-form-row__label required">下單手續費率(%)：</label>
        <div className="admin-form-row__control admin-form-row__control--suffix">
          <input
            type="number"
            min="0"
            step="any"
            value={form.handlingFeeRate}
            onChange={(e) => onChange('handlingFeeRate', e.target.value)}
            required
          />
          <span className="admin-form-row__suffix">%</span>
        </div>
      </div>

      {playType === 'TIME_LIMITED' && !hideTimedDurationFields && (
        <>
          <div className="admin-form-row">
            <label className="admin-form-row__label required">持倉秒數：</label>
            <div className="admin-form-row__control">
              <input
                type="number"
                min="1"
                value={form.durationSeconds}
                onChange={(e) => onChange('durationSeconds', e.target.value)}
                required
              />
            </div>
          </div>
          <div className="admin-form-row">
            <label className="admin-form-row__label required">賠率：</label>
            <div className="admin-form-row__control">
              <input
                type="number"
                min="0"
                step="any"
                value={form.payoutOdds}
                onChange={(e) => onChange('payoutOdds', e.target.value)}
                required
              />
            </div>
          </div>
        </>
      )}

      {playType === 'PERPETUAL' && (
        <>
          <div className="admin-form-row">
            <label className="admin-form-row__label required">預設槓桿：</label>
            <div className="admin-form-row__control">
              <input
                type="number"
                min="1"
                value={form.defaultLeverage}
                onChange={(e) => onChange('defaultLeverage', e.target.value)}
                required
              />
            </div>
          </div>
          <div className="admin-form-row">
            <label className="admin-form-row__label required">最大槓桿：</label>
            <div className="admin-form-row__control">
              <input
                type="number"
                min="1"
                value={form.maxLeverage}
                onChange={(e) => onChange('maxLeverage', e.target.value)}
                required
              />
            </div>
          </div>
          <div className="admin-form-row">
            <label className="admin-form-row__label">鎖倉天數：</label>
            <div className="admin-form-row__control">
              <input
                type="number"
                min="0"
                step="any"
                value={form.stakingTime}
                onChange={(e) => onChange('stakingTime', e.target.value)}
              />
            </div>
          </div>
        </>
      )}

      <div className="admin-form-row">
        <label className="admin-form-row__label">快速下單：固定金額(USDT)</label>
        <div className="admin-form-row__control">
          <input
            type="text"
            value={form.quickAmounts}
            onChange={(e) => onChange('quickAmounts', e.target.value)}
            placeholder="10, 50, 300, 500, 1000"
          />
          <p className="form-hint">以「,」區隔，最多 5 組。</p>
        </div>
      </div>

      <div className="admin-form-row">
        <label className="admin-form-row__label">快速下單：餘額百分比(%)</label>
        <div className="admin-form-row__control">
          <input
            type="text"
            value={form.quickRatios}
            onChange={(e) => onChange('quickRatios', e.target.value)}
            placeholder="20, 25, 50, 75, 100"
          />
          <p className="form-hint">以「,」區隔，最多 5 組。</p>
        </div>
      </div>

      {selectedSymbol && !pairReadonly && (
        <p className="form-hint">
          資產類別：{assetClassLabel(selectedSymbol.assetClass)}
          {selectedSymbol.orderDisabledPeriodEnabled ? '（休市不可下單）' : ''}
        </p>
      )}

      {playType === 'FUTURES' && (
        <p className="form-hint">交割合約將自動建立 60s～30m 六個週期子商品，並預生成局。</p>
      )}

      {playType === 'TIME_LIMITED' && hideTimedDurationFields && (
        <p className="form-hint">
          限時交易將自動建立 5、10、15、30、300 秒五個結算時間子商品（收益率預設 30%～150%）。
        </p>
      )}
    </>
  );
}

export function OrderProductCreateModal({
  open,
  categoryKey,
  form,
  symbols,
  symbolsLoading,
  submitting,
  onClose,
  onCategoryChange,
  onChange,
  onSubmit,
}) {
  if (!open) {
    return null;
  }
  const category = CREATE_CATEGORIES.find((item) => item.key === categoryKey);
  const playType = category?.playType;

  return (
    <div className="admin-modal-overlay" role="presentation" onClick={onClose}>
      <div
        className="admin-modal admin-modal--wide"
        role="dialog"
        aria-labelledby="create-product-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="admin-modal__header">
          <h3 id="create-product-title">新增</h3>
          <button type="button" className="admin-modal__close" onClick={onClose}>
            ×
          </button>
        </div>
        <form className="admin-modal__body admin-modal__body--form" onSubmit={onSubmit}>
          <div className="admin-form-row">
            <label className="admin-form-row__label required">交易類型：</label>
            <div className="admin-form-row__control">
              <PlayTypeRadios value={categoryKey} onChange={onCategoryChange} />
            </div>
          </div>
          <ProductFormFields
            form={form}
            onChange={onChange}
            playType={playType}
            symbols={symbols}
            symbolsLoading={symbolsLoading}
            hideTimedDurationFields={playType === 'TIME_LIMITED'}
          />
          <div className="admin-modal__footer admin-modal__footer--center">
            <button type="submit" className="btn btn-success" disabled={submitting}>
              {submitting ? '提交中…' : '提交'}
            </button>
            <button type="button" className="btn btn-danger" onClick={onClose}>
              關閉
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

function DetailRow({ label, value }) {
  return (
    <div className="product-detail-row">
      <span className="product-detail-row__label">{label}</span>
      <span className="product-detail-row__value">{value ?? '—'}</span>
    </div>
  );
}

export function OrderProductDetailModal({
  open,
  product,
  form,
  periods,
  onClose,
  onEdit,
}) {
  if (!open || !product) {
    return null;
  }

  return (
    <div className="admin-modal-overlay" role="presentation" onClick={onClose}>
      <div
        className="admin-modal admin-modal--wide"
        role="dialog"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="admin-modal__header">
          <h3>
            詳情 [{product.displayName || product.marketSymbolCode}]
          </h3>
          <button type="button" className="btn btn-success btn-sm" onClick={onEdit}>
            修改
          </button>
          <button type="button" className="admin-modal__close" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="admin-modal__body product-detail-grid">
          <DetailRow label="交易類型" value={playTypeLabel(product.playType)} />
          <DetailRow label="交易對" value={product.name} />
          <DetailRow label="自定義名稱" value={form.customName || '—'} />
          <DetailRow label="商品圖標顯示" value={form.showIcon ? '開啟' : '關閉'} />
          <DetailRow label="前台顯示轉換匯率" value={form.conversionRate} />
          <DetailRow label="顯示每克價格" value={form.showPricePerGram ? '開啟' : '關閉'} />
          <DetailRow label="狀態" value={form.status === 'enabled' ? '啟用' : form.status === 'no_order' ? '禁止下單' : '禁用'} />
          <DetailRow label="顯示順序" value={product.sort} />
          <DetailRow label="最小下單金額(USDT)" value={Number(form.minOrderAmount) > 0 ? form.minOrderAmount : '不限制'} />
          <DetailRow label="最大下單金額(USDT)" value={Number(form.maxOrderAmount) > 0 ? form.maxOrderAmount : '不限制'} />
          <DetailRow label="下單手續費率(%)" value={`${form.handlingFeeRate} %`} />
          <DetailRow label="快速下單：固定金額(USDT)" value={form.quickAmounts || '—'} />
          <DetailRow label="快速下單：餘額百分比(%)" value={form.quickRatios || '—'} />
          {product.playType === 'FUTURES' && periods.length > 0 && (
            <div className="product-detail-periods">
              <strong>交割週期子商品</strong>
              <ul>
                {periods.map((item) => (
                  <li key={item.id}>
                    {item.periodLabel}（{item.futuresPeriodType}）
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
        <div className="admin-modal__footer admin-modal__footer--center">
          <button type="button" className="btn btn-danger" onClick={onClose}>
            關閉
          </button>
        </div>
      </div>
    </div>
  );
}

function StatusRadios({ value, onChange }) {
  const options = [
    { value: 'enabled', label: '啟用' },
    { value: 'disabled', label: '禁用' },
    { value: 'no_order', label: '禁止下單' },
  ];
  return (
    <div className="product-status-radios">
      {options.map((item) => (
        <label key={item.value} className="product-status-radios__item">
          <input
            type="radio"
            name="productStatus"
            value={item.value}
            checked={value === item.value}
            onChange={() => onChange(item.value)}
          />
          <span>{item.label}</span>
        </label>
      ))}
    </div>
  );
}

export function OrderProductEditModal({
  open,
  product,
  form,
  symbols,
  submitting,
  onClose,
  onChange,
  onReset,
  onSubmit,
}) {
  if (!open || !product) {
    return null;
  }

  return (
    <div className="admin-modal-overlay" role="presentation" onClick={onClose}>
      <div
        className="admin-modal admin-modal--wide"
        role="dialog"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="admin-modal__header">
          <h3>修改</h3>
          <button type="button" className="admin-modal__close" onClick={onClose}>
            ×
          </button>
        </div>
        <form className="admin-modal__body admin-modal__body--form" onSubmit={onSubmit}>
          <div className="admin-form-row">
            <label className="admin-form-row__label required">狀態：</label>
            <div className="admin-form-row__control">
              <StatusRadios value={form.status} onChange={(v) => onChange('status', v)} />
            </div>
          </div>

          <div className="admin-form-row">
            <label className="admin-form-row__label required">交易類型：</label>
            <div className="admin-form-row__control">
              <input type="text" value={playTypeLabel(product.playType)} disabled />
            </div>
          </div>

          <div className="admin-form-row">
            <label className="admin-form-row__label">顯示順序：</label>
            <div className="admin-form-row__control">
              <input
                type="number"
                min="0"
                value={form.sort}
                onChange={(e) => onChange('sort', e.target.value)}
              />
            </div>
          </div>

          <ProductFormFields
            form={form}
            onChange={onChange}
            playType={product.playType}
            symbols={symbols}
            symbolsLoading={false}
            pairReadonly
            hideTimedDurationFields={product.playType === 'TIME_LIMITED'}
          />

          <div className="admin-modal__footer admin-modal__footer--center">
            <button type="submit" className="btn btn-success" disabled={submitting}>
              {submitting ? '提交中…' : '提交'}
            </button>
            <button type="button" className="btn btn-warning" onClick={onReset}>
              重置
            </button>
            <button type="button" className="btn btn-danger" onClick={onClose}>
              關閉
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export { CREATE_CATEGORIES };
